import { AuthTokenPayload, User, UserRole } from '../types/UserInterface';

export function decodeJWT(token: string): AuthTokenPayload | null {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload) as AuthTokenPayload;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const payload = decodeJWT(token);
  if (!payload) return true;
  return Date.now() >= payload.exp * 1000;
}

// Role is not in the JWT — derive it from scopeId or default to Staff
function deriveRole(scopeId: string): UserRole {
  if (scopeId === 'admin') return 'Admin';
  if (scopeId === 'manager') return 'Manager';
  return 'Staff';
}

export function extractUserFromToken(token: string): User | null {
  const payload = decodeJWT(token);
  if (!payload) return null;
  return {
    userId:    payload.userId,
    tenantId:  payload.tenantId,
    clientId:  payload.clientId,
    email:     payload.email,
    phone:     payload.phone,
    firstName: payload.firstName,
    lastName:  payload.lastName,
    scopeId:   payload.scopeId,
    role:      deriveRole(payload.scopeId),
    createdAt: payload.createdAt,
    updatedAt: payload.updatedAt,
  };
}